export const ENVIRONMENT_NAME = process.env.REACT_APP_ENVIRONMENT_NAME;

export const ENDPOINTS = {
  getWorkshops: "/workshop",
  bookWorkshop: "/Appointment/class",
} as const;
